module.exports = __webpack_public_path__ + "img/icon-average-gas-consumption.daf59c95.svg";